import './RGFT.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class RGFT extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initRgftForm();
	}

	async initRgftForm () {
		const form = document.getElementById('rgft-form');

		if (!form) {
			return;
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		new HTMLFormValidator({
			errorInsertPosition: 'afterend',
			fieldContainer: '.g-account-control-form',
			formElement: form
		});
	}
}
